import {ConnectionUser} from '@lib/store';
import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';

export const SECTION_ID_CONNECTION_WITHOUT_WORKDAY = 'SECTION_ID_CONNECTION_WITHOUT_WORKDAY';

export const constructConnectionFilterWithoutWorkday = (connections: ConnectionUser[], t: TFunction) => {
  return constructFilter({
    sectionId: SECTION_ID_CONNECTION_WITHOUT_WORKDAY,
    sectionTitle: t('connection:ConnectionsNotGoingToTheOffice'),
    dontCollaplseOptionsAboveThreshold: true,
    type: 'or',
    data: connections.map((c) => ({
      id: c.id,
      label: c.name,
      email: c.email,
      avatarData: {imageHash: c.imageHash, initials: c.initials, email: c.email},
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: ConnectionUser) => filter.id === entity.id,
  });
};
